import React from 'react';
import { LegalDocumentPage } from './LegalDocumentPage';

const sections = [
  {
    title: '서비스 목적과 적용 범위',
    body: [
      '짬밥요리사는 군 생활 정보, 식단 조회, 국방 뉴스, 예비군 정보, 커뮤니티, 주문 및 결제 기능을 제공하는 웹 서비스입니다.',
      '본 약관은 짬밥요리사 웹사이트와 그에 부속된 모든 기능을 이용하는 사용자에게 적용되며, 회원가입 또는 서비스 이용 시 약관에 동의한 것으로 봅니다.',
    ],
  },
  {
    title: '회원 계정과 이용자 책임',
    body: [
      '사용자는 소셜 로그인 등 운영팀이 제공하는 인증 수단을 통해 서비스를 이용할 수 있으며, 본인 계정으로 이루어진 활동에 대한 책임을 부담합니다.',
      '계정 정보가 도용되었거나 비정상적인 접근이 의심되는 경우에는 즉시 로그아웃하고 운영팀에 알려야 합니다.',
    ],
    bullets: [
      '타인의 계정을 무단 사용하거나 사칭해서는 안 됩니다.',
      '허위 정보로 회원가입하거나 프로필을 설정해서는 안 됩니다.',
      '계정 보안 유지를 위해 비정상 이용 정황이 확인되면 일부 기능이 제한될 수 있습니다.',
    ],
  },
  {
    title: '서비스 제공과 변경',
    body: [
      '운영팀은 서비스 안정성, 보안, 정책 변경, 기능 개선을 위해 일부 기능을 수정하거나 중단할 수 있습니다.',
      '외부 API, 공공 데이터, 제휴 서비스에 의존하는 기능은 제공기관의 사정에 따라 지연되거나 일시적으로 중단될 수 있습니다.',
    ],
    bullets: [
      '정기 점검 또는 긴급 점검 시 일부 기능 이용이 제한될 수 있습니다.',
      '결제, 뉴스, 식단, 지도 기능은 외부 서비스 상태에 영향을 받을 수 있습니다.',
      '중요한 변경이 있는 경우 서비스 화면 또는 공지로 안내합니다.',
    ],
  },
  {
    title: '커뮤니티 운영 정책',
    body: [
      '사용자는 커뮤니티를 이용할 때 관련 법령과 공공질서를 준수해야 하며, 타인의 권리나 안전을 침해하는 게시물을 등록해서는 안 됩니다.',
      '운영팀은 신고 또는 모니터링을 통해 부적절한 게시물을 검토하며, 필요한 경우 게시물 삭제, 노출 제한, 계정 제한 조치를 취할 수 있습니다.',
    ],
    bullets: [
      '욕설, 비방, 허위사실 유포, 도배, 광고, 사칭 행위 금지',
      '개인정보, 군 관련 민감 정보, 기밀성 높은 자료 게시 금지',
      '반복적 정책 위반 시 서비스 이용이 제한될 수 있음',
    ],
  },
  {
    title: '주문, 결제 및 환불',
    body: [
      '상품 또는 유료 기능이 제공되는 경우 결제 완료 시점에 주문이 성립하며, 세부 조건은 각 결제 화면 또는 별도 안내를 따릅니다.',
      '환불 가능 여부는 상품 성격, 사용 여부, 결제 상태, 관계 법령에 따라 달라질 수 있습니다.',
    ],
    bullets: [
      '결제 오류나 승인 지연은 카드사, 은행, 외부 결제사 사정으로 발생할 수 있습니다.',
      '이상 결제나 부정 사용이 의심되는 경우 추가 확인 절차가 진행될 수 있습니다.',
      '환불은 운영 정책과 관련 법령이 허용하는 범위에서 처리됩니다.',
    ],
  },
  {
    title: '지식재산권과 서비스 자료 이용',
    body: [
      '짬밥요리사의 디자인, 로고, 텍스트, 데이터 구성, 소프트웨어 및 운영 자료에 대한 권리는 운영팀 또는 정당한 권리자에게 귀속됩니다.',
      '사용자는 운영팀의 사전 동의 없이 서비스 자료를 무단 복제, 배포, 전송, 판매, 2차 가공할 수 없습니다.',
    ],
  },
  {
    title: '책임 제한',
    body: [
      '운영팀은 외부 기관이나 외부 API에서 제공받은 정보의 정확성, 완전성, 최신성을 보장하지 않습니다.',
      '천재지변, 통신 장애, 시스템 점검, 외부 서비스 장애 등 운영팀이 합리적으로 통제할 수 없는 사유로 발생한 손해에 대해서는 관련 법령 범위 내에서 책임이 제한될 수 있습니다.',
    ],
  },
  {
    title: '약관의 개정',
    body: [
      '운영팀은 서비스 운영, 정책, 관계 법령의 변경에 따라 본 약관을 개정할 수 있습니다.',
      '개정 약관은 적용일 이전에 공지되며, 공지 후에도 서비스를 계속 이용하는 경우 변경된 약관에 동의한 것으로 봅니다.',
    ],
  },
] as const;

export const TermsOfServicePage: React.FC = () => {
  return (
    <LegalDocumentPage
      eyebrow="Service Policy"
      title="이용약관"
      description="짬밥요리사 서비스 이용에 적용되는 기본 원칙, 회원 책임, 커뮤니티 운영 기준, 결제 및 주문 정책을 안내합니다."
      sections={[...sections]}
    />
  );
};
